import { render, staticRenderFns } from "./NoTierModal.vue?vue&type=template&id=36927f86&scoped=true"
import script from "./NoTierModal.vue?vue&type=script&lang=js"
export * from "./NoTierModal.vue?vue&type=script&lang=js"
import style0 from "./NoTierModal.vue?vue&type=style&index=0&id=36927f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36927f86",
  null
  
)

export default component.exports